export const specialities = {
  state: {
    specialityId: null,
    specialityFilterId: null,
    specialitiesList: []
  },
  mutations: {
    setSpecialityId(state, val) {
      state.specialityId = val
    },
    setSpecialitiesList(state, val) {
      state.specialitiesList = val
    },
    setSpecialityFilterId(state, val) {
      state.specialityFilterId = val
    },
  },
  getters: {
    specialityId(state) {
      return state.specialityId
    },
    specialitiesList(state) {
      return state.specialitiesList
    },
    specialityName(state) {
      const selectedSpec = state.specialitiesList.find(it => it.id === state.specialityId)
      if (selectedSpec === undefined) {
        return ''
      }
      return selectedSpec.name
    },
    specialityFilterId(state) {
      return state.specialityFilterId
    },
    specialityFilterName(state) {
      const selectedSpec = state.specialitiesList.find(it => it.id === state.specialityFilterId)
      if (selectedSpec === undefined) {
        return ''
      }
      return selectedSpec.name
    }
  }
}